import { Component, EventEmitter, Input, Output } from '@angular/core'
import { RequestedUpdateFields } from '../../model/candidate-application.model'
import { UserMode } from '../../model/component-modes.enum'
import { ISocialMedia } from '../../model/social-media.enum'

@Component({
  selector: 'candidate-social-media',
  template: `
    <!-- Request Information -->
    <e11-empty-state
      *ngIf="!social && userMode !== userModeEnum.Candidate"
      [icon]="'workspaces'"
      [iconSize]="'md-36'"
      containerClassOverrides="e11-mt-0"
      title="{{ 'No Social Media' | translate }}"
      [subtitle]="
        openRequest
          ? 'Requested on ' + (requestTimestamp | date : 'MM/dd/yyyy - hh:mm a')
          : ('Candidate did not supply any social media links.' | translate)
      "
      [clickable]="false"
      [borderColor]="openRequest ? 'e11-border-skin-secondary' : ''"
      [showButton]="true"
      [buttonValue]="openRequest ? 'Pending Request' : 'Request Social Media'"
      [buttonColor]="
        openRequest
          ? 'e11-border-skin-secondary e11-text-skin-secondary'
          : 'e11-border-skin-primary-accent hover:e11-bg-skin-primary-accent/20 e11-text-skin-primary-accent'
      "
      [buttonIcon]="openRequest ? 'pending' : ''"
      (buttonClicked)="!requestsDisabled && requestModal()"
      [disabled]="!!openRequest"
    >
    </e11-empty-state>
  `,
})
export class CandidateSocialComponent {
  @Input() social: ISocialMedia | undefined
  @Input() openRequest?: RequestedUpdateFields
  @Input() requestsDisabled = false
  @Input() userMode = UserMode.Candidate
  @Input() requestTimestamp?: string
  @Output() requestFromComponent = new EventEmitter()

  userModeEnum = UserMode

  constructor() {}

  requestModal() {
    this.requestFromComponent.emit('SocialMedia')
  }
}
